import { ShoppingBag, SportsMotorsports } from "@mui/icons-material";
import React from 'react';
// import AddressLine from "../web_pages/RestaurantPage/RestDetails/addressLine";



//תוכן חלוקת המגש - בפיצריות
const conten = (spec, item) => {
    if (spec.splitSelected != null) {
        let bk = "";
        switch (spec.splitSelected) {
            case "lHalf":
                {
                    bk = "חצי שמאל";
                    break;
                }
            case "rHalf":
                {
                    bk = "חצי ימין";
                    break;
                }
            case "rtQuart":
                {
                    bk = "רבע ימין עליון";
                    break;
                }
            case "rbQuart":
                {
                    bk = "רבע ימין תחתון";
                    break;
                }
            case "ltQuart":
                {
                    bk = "רבע שמאל עליון";
                    break;
                }
            case "lbQuart":
                {
                    bk = "רבע שמאל תחתון";
                    break;
                }
            default:
                bk = "כל המגש";
                break;

        }
        return (<span className={"regular"}>{bk}</span>)
    }
    else {
        return (<span className={"regular"}>{spec.addToPrice > 0 ? `X ${item.mount} ` : ""}</span>)
    }

}



const getSelectedOptionsPrice = (selectedOptions) => {
    // Initialize total items to 0
    let totItms = 0;
console.log(selectedOptions);
    // Check if selectedOptions array is not empty
    if (selectedOptions.length > 0) {
        totItms = selectedOptions.reduce((total, item) => {
            // Parse addToPrice to ensure it's a number or default to 0
            const addToPrice = parseFloat(item.addToPrice || 0);

            // Check if addToPrice is valid and greater than 0
            if (!isNaN(addToPrice) && addToPrice > 0) {
                // Ensure mount is at least 1
                const mount = item.mount > 0 ? item.mount : 1;

                // Add to the total
                return total + addToPrice * mount;
            }

            // Skip invalid items
            return total;
        }, 0);
    }

    // Return the final total, parsed as a float for safety
    return parseFloat(totItms);
};

const getOrderTotalPrice = (theOrder) => {

    let tot = 0;
    if (theOrder.OrderType == "Deliver") {
        tot = parseInt(theOrder.OrderDelPrice);
    }
    theOrder.Orders.map((item, index) => {

        if (item.specials.length > 0) {
            item.specials.map((special, specialIndex) => {
                special.spec.map((spec, specIndex) => {
                    if (parseFloat(spec.addToPrice) > -1) {
                        tot += parseFloat(spec.addToPrice) * parseInt(item.mount);
                    }
                })
            })
        }
        tot += parseFloat(item.prodPrice) * parseInt(item.mount);

    })

    return tot;
}

const getProdPriceWithSPecials = (theItem) => {
    let tot = 0;


    theItem.specials.map((special, specialIndex) => {
        special.spec.map((spec, specIndex) => {
            if (parseFloat(spec.addToPrice) > -1) {
                tot += parseFloat(spec.addToPrice) * parseInt(theItem.mount);
            }
        })
    })

    tot += parseFloat(theItem.prodPrice) * parseInt(theItem.mount);


    return tot;
}


const getOrderPrice = (theOrder) => {
    let tot = 0;

    theOrder.Orders.map((item, index) => {

        if (item.specials.length > 0) {
            item.specials.map((special, specialIndex) => {
                special.spec.map((spec, specIndex) => {
                    if (parseFloat(spec.addToPrice) > -1) {
                        tot += parseFloat(spec.addToPrice) * parseInt(item.mount);
                    }
                })
            })
        }
        tot += parseFloat(item.prodPrice) * parseInt(item.mount);

    })

    return tot;
}

const takeAwayBlock = (theTime, Address) => {
    return (
        <>
            <div className={"takeAwayBlock"}>
                <div className={"theImg"}>
                    <ShoppingBag />
                </div>
                {/* <div className={"theImg"} style={{ backgroundImage: `url("/PermanentImages/take.png")` }}></div> */}
                <div className={"txtOrdType"}>
                    <div className={"bold big"} >איסוף עצמי</div>
                    <div className={"regular"} >{theTime}</div>
                    {/* <div className={"regular"} ><AddressLine address={Address} typeDisp="NoIcon" /></div> */}

                </div>


            </div>
        </>
    )
}

    //אופן תשלום
    const payingTYpe = (theOrder) => {

        switch (theOrder?.PaymentType) {
            case "0":
                return "אשראי";
            case "1":
                return "מזומן";
            case "2":
                return "ביט";
        }
    }

    
const deliveryBlock = (theTime, thePrice) => {
    return (
        <>
            <div className={"takeAwayBlock"}>
                <div className={"theImg"}>
                    <SportsMotorsports />
                </div>
                <div className={"txtOrdType"}>
                    <div className={"bold big"} >משלוח</div>
                    <div className={"regular"} >{theTime}</div>
                    <div className={"regular"} >מחיר משלוח:  ₪{thePrice}</div>
                </div>
            </div>
        </>
    )
}


const clearOrd = () => {
    let ord = { restId: "", currentP: [], Orders: [] };

    let stringOrd = JSON.stringify({ ...ord });
    sessionStorage.setItem("am_order", stringOrd)

    return (ord);

}


export default {
    getOrderTotalPrice,
    getOrderPrice,
    takeAwayBlock,
    deliveryBlock,
    clearOrd,
    conten,
    getProdPriceWithSPecials,
    payingTYpe,
    getSelectedOptionsPrice
};